import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'

const PhoneConfirmationService = {
  // Check for valid phone number. Is it check that phoneNumber isnt allready used?
  GetPhoneConfirmation (phoneNumber: string) {
    return ApiService.getAsync(proxy.Userv2, `Confirmation?phoneNumber=%2B${phoneNumber}`)
  },
  // Broadcast confirmation code
  SendConfirmationCode (phoneNumber: string) {
    return ApiService.postAsync(proxy.Userv2, `Confirmation?phoneNumber=%2B${phoneNumber}`, phoneNumber)
  },
  V2SendConfirmationCode (phoneNumber: string) {
    return ApiService.postAsync(proxy.Userv3, `Confirmation?phoneNumber=%2B${phoneNumber}`, phoneNumber)
  },
  // Confirm mobilePhone
  ConfirmMobilePhone (identifier: string, confirmationCode: string) {
    return ApiService.putAsync(proxy.Userv2, 'Confirmation', { Identifier: identifier, ConfirmationCode: confirmationCode })
  },
  V5SendConfirmationCode (phoneNumber: string, confirmationChannel: string) {
    return ApiService.postAsync(proxy.Userv5, `Confirmation?phoneNumber=%2B${phoneNumber}&confirmationChannel=${confirmationChannel}`, phoneNumber)
  }
}
export default PhoneConfirmationService
